import { Component, Prop, Vue, Watch, Ref } from 'vue-property-decorator'
import nodesService from '@/diagrams/services/nodes-service'
import CreateNodeEvent from '@/diagrams/events/create-node-event'
import EditNodeEvent from '@/diagrams/events/edit-node-event'
import Entity from '@/common/models/entity'
import Node from '@/diagrams/models/node'
import Project from '@/projects/entities/project'
import NodeEntity from '@/common/models/node-entitiy'
import { KeywordType } from '@/diagrams/models/keyword-type'
import Action from '@/diagrams/models/action'
import EmergoDialog from '@/emergo/components/emergo-dialog/emergo-dialog'
import EmergoResponse from '@/emergo/models/emergo_response'
import NodeEntityResponse from '@/common/models/node-entity-response'

@Component
export default class NodeEditor extends Vue {
  @Prop({ required: true })
  private className!: NodeClassName

  @Prop({ required: true })
  private creator!: (evt: CreateNodeEvent) => NodeEntity

  @Prop({ default: (m: any, s: any) => m })
  private selector!: (model: any, selected: any) => NodeEntity

  @Prop({ default: false })
  private archived!: boolean

  @Ref()
  private validator!: ValidationObserver

  @Ref()
  private dialog!: EmergoDialog

  private createNodeEvent!: CreateNodeEvent
  private debounceWait = 1000
  private loading = false
  private showCreateEntityButton = false
  // TODO: Suboptimal. Die entity sollte irgenwie anders gesetzt werden.
  private model: NodeEntity = this.creator(
    new CreateNodeEvent(new Project(), new Node(), this.className)
  )
  private isSaving = false

  @Watch('model', { deep: true })
  private modelChanged() {
    this.$emit('modelChanged', this.model)
  }

  get keywordType() {
    switch (this.className) {
      case 'Action':
        return KeywordType.Action
      case 'ActionGroup':
        return KeywordType.Action
      case 'ProjectStakeholder':
        return KeywordType.Stakeholder
      case 'ProjectStakeholderGroup':
        return KeywordType.Stakeholder
      case 'Topic':
        return KeywordType.Topic
      case 'TopicGroup':
        return KeywordType.Topic
    }
  }

  get createEntityText() {
    switch (this.className) {
      case 'Topic':
        return 'Neues Thema'
      case 'TopicGroup':
        return 'Neue Themendimension'
      case 'Action':
        return 'Neue Maßnahme'
      case 'ActionGroup':
        return 'Neue Maßnahmengruppe'
      case 'ProjectStakeholder':
        return 'Neuer Stakeholder'
      case 'ProjectStakeholderGroup':
        return 'Neue Stakeholdergruppe'
      default:
        return ''
    }
  }

  private createNewEntity() {
    // if (this.createNodeEvent) {
    this.createNodeEvent = new CreateNodeEvent(
      new Project(),
      new Node(),
      this.className
    )
    this.$bus.$emit('node:create', this.createNodeEvent)
    this.$bus.$emit('reload-spider')
    // }
  }

  get entityName() {
    switch (this.className) {
      case 'Topic':
        return 'das Thema'
      case 'TopicGroup':
        return 'die Themendimension'
      case 'Action':
        return 'die Maßnahme'
      case 'ActionGroup':
        return 'die Maßnahmengruppe'
      case 'ProjectStakeholder':
        return 'den Stakeholder'
      case 'ProjectStakeholderGroup':
        return 'die Stakeholdergruppe'
      default:
        return 'das Objekt'
    }
  }

  private createNode(evt: CreateNodeEvent) {
    //console.log('createNode: ' + JSON.stringify(evt))
    this.showCreateEntityButton = false
    if (evt && evt.className === this.className) {
      this.model = this.creator(evt)
      this.reset()
    }
  }

  private async editNodeAsync(evt: EditNodeEvent) {
    this.createNodeEvent = new CreateNodeEvent(
      evt.project,
      evt.node,
      this.className
    )

    //console.log('createNodeEvent: ' + JSON.stringify(this.createNodeEvent))

    this.showCreateEntityButton = true
    const node = evt.node
    if (node && node.className === this.className) {
      this.loading = true
      const res = await nodesService.findOneAsync<NodeEntity>(
        node.className,
        node.dbId
      )
      if (res) {
        this.model = res
      }
      this.loading = false
      this.reset()
    }
  }

  private async saveAsync() {
    if ((await this.validator.validate()) && !this.isSaving) {
      this.isSaving = true
      this.$bus.$emit('db:state', 'saving')
      this.model = await nodesService.saveAsync(this.className, this.model)
      this.$bus.$emit('db:state', 'persisted')
      this.$bus.$emit('reload-spider')
      this.isSaving = false
    }
  }

  private async emergoResponseReceived(response: EmergoResponse) {
    if (this.className != 'TopicGroup') {
      return
    }

    if (response.response_informative) {
      ;(this.model as NodeEntityResponse).proactiveMessage =
        response.response_informative
    }

    if (response.response_reactive) {
      ;(this.model as NodeEntityResponse).reactiveMessage =
        response.response_reactive
    }

    await this.saveAsync()
  }

  private async selectAndSaveAsync(selected: NodeEntity) {
    this.model = this.selector(this.model, selected)
    await this.saveAsync()
  }

  private reset() {
    if (this.validator) {
      this.validator.reset()
    }
  }

  private async created() {
    this.$bus.$on('node:create', this.createNode)
    this.$bus.$on('node:edit', this.editNodeAsync)
    this.$bus.$on('emergo:response', this.emergoResponseReceived)
  }

  private openDialog() {
    this.dialog.open(
      this.createNodeEvent.project.name,
      this.createNodeEvent.project.description,
      this.model
    )
  }
}
